import React, { useContext, useEffect, useState } from 'react'
import GameContext from '../context/game/GameContext'
import Box from './Box'
function Board() {
    const context = useContext(GameContext)
    const { GameR} = context
    let id = 0
    let rid = 0
    const handelClick = () => {
        if (document.getElementById('CompleteModal').classList.contains('hidden')) {
            document.getElementById('CompleteModal').classList.remove('hidden')
            document.getElementById('CompleteModal').classList.add('flex')
        }
        else {
            document.getElementById('CompleteModal').classList.add('hidden')
            document.getElementById('CompleteModal').classList.remove('flex')
        }
    }
    const handelbutton = (i) => {
        if (i == 1) {
            handelClick()
            if (document.getElementById('defaultModal').classList.contains('hidden')) {
                document.getElementById('defaultModal').classList.remove('hidden')
                document.getElementById('defaultModal').classList.add('flex')
            }
        }
        else {
            handelClick()
        }
    }
    return (
        <>
            <div id="CompleteModal" className="hidden overflow-y-auto overflow-x-hidden absolute top-52 right-32 left-0 z-50 w-full md:inset-0 md:h-full justify-center items-center">
                <div className="bg-black relative p-4 w-full max-w-2xl h-full md:h-auto">
                    <div className="relative bg-white rounded-lg shadow">
                        <div className="flex justify-between items-start p-4 rounded-t border-b">
                            <h3 className="text-xl font-semibold text-gray-900">Great job on completing the Sudoku game!</h3>
                            <button onClick={handelClick}><i className="text-xl hover:bg-gray-300 px-1 cursor-pointer rounded-md fa-solid fa-xmark"></i></button>
                        </div>
                        <div className="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200">
                            <span className='flex items-center text-lg font-serif font-bold w-full'>Would you like to play again?</span>
                            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:cursor-not-allowed" onClick={() => handelbutton(1)}>Yes</button>
                            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:cursor-not-allowed" onClick={() => handelbutton(0)}>No</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex flex-col items-center justify-center lg:block'>
                {localStorage.getItem('token') ?
                    <div className='select-none cursor-grabbing p-2 my-2 rounded-lg text-white lg:absolute mx-32 bg-red-300 shadow-xl hover:bg-red-400 w-fit'>
                        <span>{localStorage.getItem('username')}</span>
                        <br />
                        <span>{localStorage.getItem('email')}</span>
                    </div> : <div className='select-none cursor-grabbing p-2 my-2 rounded-lg text-white lg:absolute mx-32 bg-red-300 shadow-xl hover:bg-red-400 w-72'><span>Note: You are currently playing the game as a guest, and your progress won't be saved in the dashboard. If you want to save your data, please log in to your account. </span></div>
                }
                <div id='timer' className='select-none cursor-grabbing p-2 rounded-lg text-white lg:absolute lg:right-4 lg:mx-32 bg-red-300 hover:bg-red-400 w-fit'>00:00:00:00
                </div>
                <div className='flex my-12 justify-center items-center'>
                    <table className='border-4 border-black  bg-green-200'>
                        <tbody>
                            {GameR.map((element) => {
                                return <tr className='' key={rid++}>{element.map((subElement) => {
                                    return <Box key={id++} id={id} num={subElement}></Box>
                                })}</tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

        </>
    )

}

export default Board
